import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation, useWhoamiMutation } from '../../api/LoginAPI';
import { setAuthCheckFinished, setLogin, setLogout } from '../../Slice/AuthSlice';
import { setLoginVisible } from '../../Slice/DialogSlice';
import { AppDispatch, RootState } from '../../Store';
import styles from './header.module.scss';
import ChatButtonComponent from '../../component/chat/ChatButtonComponent/ChatButtonComponent';
import LogoComponent from '../../component/LogoComponent';

export default function LandingpageHeader() {

    //const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.authSlice.auth);
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    //const { t } = useTranslation();
    const [logoutAPI] = useLogoutMutation();
    const [whoamiAPI] = useWhoamiMutation();

    function handleShowLoginDialog() {
        dispatch(setLoginVisible(true));
    }

    useEffect(() => {
        if (!auth.isAuthCheckFinished) {
            whoamiAPI().unwrap()
                .then(resp => dispatch(setLogin(resp)))
                .catch(error => {
                    dispatch(setAuthCheckFinished(true));
                    console.log(error);
                    navigate({
                        pathname: "/",
                        search: ""
                    });
                });
        }
    }, [])

    return (
        <div className={styles.headerContainer}>

            <div className={styles.headerLogo}  >
                <LogoComponent />
            </div>

            <div className={styles.headerLoginArea}>
                {(auth.isAuthCheckFinished &&
                    <>
                        {(auth.isAuthenticated === false) ?

                            <button
                                className="btn btn-primary pg-btn-login"
                                onClick={handleShowLoginDialog}
                                style={{padding:"10px 50px", fontWeight:"bold", fontSize:"1.0rem"}}
                            > Login </button>

                            :
                            <>
                                <span><ChatButtonComponent /></span>

                                <span title="Account" onClick={() => navigate("/account")}><i title="Account" className='bi bi-person-circle' style={{ cursor: "pointer" }} ></i></span>

                                {auth.user?.email}

                                <span title="Logout" onClick={() =>
                                    logoutAPI()
                                        .then(() => dispatch(setLogout()))
                                        .then(() => navigate('/'))}>

                                    <i className='bi bi-box-arrow-right' style={{ cursor: "pointer", color: "red" }} ></i>
                                </span>
                            </>
                        }
                    </>)}

            </div>

        </div >
    );
}

